import React from 'react';
import '../../styles/Sidebar.css';
import NavbarButton from '../elements/NavbarButton';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import { logout } from '../../api/userApi';
import { useNavigate } from 'react-router-dom';

type SidebarProps = {
  children?: React.ReactNode;
  onLogout?: () => void;
};

const Sidebar: React.FC<SidebarProps> = ({ children, onLogout }) => {
  const navigate = useNavigate()
  return (
    <div className="sidebar">
      <div className="sidebar-content">
        {children}
      </div>
      {onLogout && (
        <NavbarButton
                        text="Logout"
                        icon={LogoutRoundedIcon}
                        fontSize="18px"
                        fontWeight={600}
                        backgroundColor="#fff"
                        color="var(--primary)"
                        onClick={() => { logout(); navigate('/login') }}
                    />
      )}
    </div>
  );
};

export default Sidebar;
